// extracted by mini-css-extract-plugin
export var Main = "main-module--Main--2lGuG";
export var Content = "main-module--Content--19Nm9";